import { Token } from "@0xsquid/squid-types";
import axios from "axios";
import { internalSquidApiBaseUrl } from "../../core/constants";
import {
  ExecuteFiatQuoteResult,
  ExecuteQuoteClient,
  OnRampQuoteParams,
  OnRampTransactionStatus,
  OnrampConfigResponse,
  OnrampPaymentMethod,
  OnrampQuoteResponse,
} from "../../core/types/onramps/onramp";

export class OnrampService {
  private readonly baseUrl = `${internalSquidApiBaseUrl}/fiat-to-crypto`;

  async getQuote(params: OnRampQuoteParams): Promise<OnrampQuoteResponse> {
    const { data } = await axios.get<OnrampQuoteResponse>(
      `${this.baseUrl}/quotes`,
      {
        params: {
          fiatCurrency: params.fiatCurrency,
          cryptoCurrencyID: params.cryptoCurrencyID,
          amount: params.amount,
          region: params.region,
          paymentMethod: params.paymentMethod,
        },
      }
    );
    return data;
  }

  async executeQuote(
    params: ExecuteQuoteClient
  ): Promise<ExecuteFiatQuoteResult> {
    const { data } = await axios.post<ExecuteFiatQuoteResult>(
      `${this.baseUrl}/execute`,
      params
    );
    return data;
  }

  async getTransactionStatus(
    transactionId: string,
    walletAddress: string,
    providerId: string
  ): Promise<OnRampTransactionStatus> {
    const { data } = await axios.get<OnRampTransactionStatus>(
      `${this.baseUrl}/status/${transactionId}`,
      {
        params: {
          providerId,
          wallet: walletAddress,
        },
      }
    );
    return data;
  }

  async getConfiguration({
    tokens,
  }: {
    tokens: Token[];
  }): Promise<OnrampConfigResponse> {
    const { data } = await axios.get<OnrampConfigResponse>(
      `${this.baseUrl}/config`
    );

    // Filter supportedCryptos to only include tokens that match our provided tokens
    const filteredCryptos = data.supportedCryptos.filter((supportedCrypto) =>
      tokens.some(
        (token) =>
          token.address.toLowerCase() ===
            supportedCrypto.address.toLowerCase() &&
          token.chainId === supportedCrypto.chainId
      )
    );

    return {
      ...data,
      supportedCryptos: filteredCryptos,
    };
  }

  async getPaymentTypes(
    fiatCurrency: string,
    cryptoCurrencyID: string,
    country?: string
  ): Promise<OnrampPaymentMethod[]> {
    const { data } = await axios.get<OnrampPaymentMethod[]>(
      `${this.baseUrl}/payment-types`,
      {
        params: {
          fiat: fiatCurrency,
          crypto: cryptoCurrencyID,
          country,
        },
      }
    );
    return data;
  }
}
